function fireFunctionOnDataTablesNativeEvents(table) {
    $('.js-data-table').on('page.dt', function (e, settings) {
        setTimeout(() => {
            addCellLabel();
        }, 0);
    });

    table.on('draw.dt', function () {
        setInfoResultsIntoMobileContainer(table.page.info().recordsDisplay);
        setResetAllControlsState();
        setEmptyStateCustomLayout();
        displayLargeDataTooltip();
        /* dataTable custom/external search highlight */
        if ($('.js-main-search').length) {
            highlightSearchResults(
                $('.dt-scroll-body'),
                $('.js-main-search').val()
            );
        }

        if ($('.js-tod-range-slider').length) {
            setResultIntoSelectedContainer();
        }

        /* dataTable built-in search highlight */
        // highlightBuiltInSearchResults($(tableVideosResults.table().body()));
    });
}

function setResultIntoSelectedContainer() {
    const text = $('.js-tod-filter-result-text');
    const $slider = $('.js-tod-range-slider');

    if (isSliderAtEdge()) {
        text.text('All');
    } else {
        text.text(`
            ${formatTime($slider.slider('values')[0])} - 
            ${formatTime($slider.slider('values')[1])}
        `);
    }
}

function customSearch(table) {
    $('.js-main-search').on('input', function () {
        table.search($(this).val(), false, true).draw();
        // table.search(d => d.includes($(this).val())).draw();
    });
}

/* HELPER FUNCTIONS */
/* SORT BY MOBILE */
function setSortByOrder(table, column, option) {
    const currentSortType = table.column(column).order()[0];

    const orderASC = [column, 'asc'];
    const orderDESC = [column, 'desc'];
    const orderNULL = [column, null];

    $('.js-sort-by-mobile').removeClass('asc desc');

    const resultContainer = $('.js-sort-by-container');
    const resultValueContainer = $('.js-sort-by-text');

    const textValue = option.find('.js-sort-by-value').text();

    if (!currentSortType) {
        table.order([orderASC]).draw();
        option.addClass('asc');

        resultContainer.addClass('active');
        resultValueContainer.html(textValue);
    } else if (currentSortType === 'asc') {
        table.order([orderDESC]).draw();
        option.removeClass('asc');
        option.addClass('desc');

        resultContainer.addClass('active');
        resultValueContainer.html(textValue);
    } else if (currentSortType === 'desc') {
        table.order([orderNULL]).draw();
        option.removeClass('asc');
        option.removeClass('desc');

        resultContainer.removeClass('active');
        resultValueContainer.html('');
    }

    /* fix displaying of card label */
    addCellLabel();
}

/* PREVENT focus on textareas in the head of select2 container */
$(document).on(
    'focus',
    '.select2-search--inline .select2-search__field',
    function () {
        $(this).blur();
    }
);

/* HIGHLIGHT SEARCH ENTERED RESULTS */
/* DataTable Search Field Custom/External*/
function highlightSearchResults(body, searchValue) {
    body.unhighlight().highlight(searchValue);
}

$(document).ready(function () {
    if ($('.js-search-custom').length) {
        highlightSearchResults(
            $('.dt-scroll-body'),
            $('.js-main-search').val()
        );

        $('.js-main-search').on('input', function () {
            highlightSearchResults($('.dt-scroll-body'), $(this).val());
        });
    }
});

/* Add Cell Labels for Mobile view */
function addCellLabel() {
    $('.js-data-table')
        .find('tr')
        .each(function () {
            $(this)
                .find('td')
                .each(function (index) {
                    $(this).attr(
                        'data-label',
                        $(this)
                            .closest('.table-wrap')
                            .find('th')
                            .eq(index)
                            .find('.dt-column-title')
                            .html()
                    );
                });
        });
}

/* Display/Hide Reset all controls */
function setResetAllControlsState() {
    const selectElements = $('.js-select2-datatable');
    const resetAllElement = $('.js-dt-reset-all-cell');
    const resetAllEmptyStateElement = $('.js-reset-all-empty-state-wrapper');

    let atLeastOneSelected = false;

    selectElements.each(function () {
        const selectedValues = $(this).val();

        if ($('.js-tod-range-slider').length) {
            if (selectedValues.length > 0 || !isSliderAtEdge()) {
                atLeastOneSelected = true;
                return false;
            }
        } else {
            if (selectedValues.length > 0) {
                atLeastOneSelected = true;
                return false;
            }
        }
    });

    if (atLeastOneSelected) {
        resetAllElement.addClass('active');
        resetAllEmptyStateElement.addClass('active');
    } else {
        resetAllElement.removeClass('active');
        resetAllEmptyStateElement.removeClass('active');
    }
}

/* Check Range Slider for Edge cases */
function isSliderAtEdge() {
    const $slider = $('.js-tod-range-slider');
    const min = $slider.slider('option', 'min');
    const max = $slider.slider('option', 'max');

    const currentMin = $slider.slider('values')[0];
    const currentMax = $slider.slider('values')[1];

    return currentMin === min && currentMax === max;
}

/* INSERT INFO RESULTS NUMBER INTO MOBILE CONTAINER */
function setInfoResultsIntoMobileContainer(count) {
    const container = $('.js-table-mobile-info-results');
    container.html(count);
}

/* Reset all results */
function resetAllResults() {
    $('.js-select2-datatable').val([]).trigger('change');
    $('.js-tod-range-slider').slider('values', [0, 1440]);
    // no need?
    // tableTrainingResults.columns().search('').draw();
}

function setSelect2PlaceholderWidth() {
    $('.select2-search__field').each(function () {
        if ($(this).closest('.selection').length) {
            const symbolWidth =
                Number($(this).css('font-size').replace('px', '')) * 0.75;
            const placeholderLength = $(this).prop('placeholder').length;
            const placeholderWidth = placeholderLength * symbolWidth;

            $(this).css('width', `${placeholderWidth}px`);
            $(this).css('max-width', `${placeholderWidth}px`);
        }
    });

    /* remove aria-hidden to fix console issue*/
    $('.dropdown-wrapper').each(function () {
        if ($(this).attr('aria-hidden') !== undefined) {
            $(this).removeAttr('aria-hidden');
        }
    });
}

function setEmptyStateCustomLayout() {
    const table = $('.dt-layout-table');
    const paging = $('.dt-paging-row');
    const emptyState = $('.js-table-empty-state');

    if (
        $('.js-data-table').dataTable().api().rows({ filter: 'applied' }).data()
            .length === 0
    ) {
        table.addClass('not-visible ovh h-0 pt-0');
        paging.addClass('dn-i');

        emptyState.addClass('active');
    } else {
        table.removeClass('not-visible ovh h-0 pt-0');
        paging.removeClass('dn-i');

        emptyState.removeClass('active');
    }
}

/* OPEN NEW PAGE BY TABLE ROW CLICK */
function openNewPageWithRowLink(url) {
    window.location.href = url;
}

$(document).on('click', '.js-dt-row-clickable', function () {
    openNewPageWithRowLink($(this).data('href'));
});

function createLargeDataTooltipLayout(data, td, ellipsisOnCard = false) {
    const layout = `<span class='dt-large-data js-dt-large-data'>
        <span class='dt-large-data-tooltip js-dt-large-data-tooltip'></span>
        <span class='dt-large-data-text js-dt-large-data-text ${
            ellipsisOnCard ? 'ellipsisOnCard' : ''
        }'>${data}</span>
    </span>`;

    if (td) {
        $(td).addClass('hide-root-content');
        $(td).append(layout);
    }

    return layout;
}

function displayLargeDataTooltip() {
    const container = $('.js-dt-large-data');
    const text = $('.js-dt-large-data-text');
    const tooltip = $('.js-dt-large-data-tooltip');

    text.each(function () {
        if ($(this).width() > $(this).closest(container).width()) {
            $(this).addClass('to-display');
            $(this).closest(container).addClass('to-display');
            $(this)
                .siblings(tooltip)
                .addClass('to-display')
                .text($(this).text());
        }
    });
}

/* should check - is it neсessary? */
/* SELECT 2 */
/* prevent search in select2 multiselect */
$(document).on(
    'select2:opening select2:closing',
    '.js-select2-datatable',
    function (event) {
        $(this)
            .parent()
            .find('.select2-dropdown .select2-search__field')
            .attr('placeholder', 'Quick search');
    }
);
/* / SELECT 2 */

/* Range filter with time format */
function formatStringToMinutes(timeString) {
    const parts = timeString.split(':');

    if (!/^\d+$/.test(parts[0]) || !/^\d{1,2}$/.test(parts[1])) {
        return null; // Invalid input
    }

    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);

    return hours * 60 + minutes;
}

function updateTimeRangeFieldsVisualFormat(minValue, maxValue) {
    var min = minValue || 0;
    var max = maxValue || 12;

    $('.js-tod-min-field').val(formatTime(min));
    $('.js-tod-max-field').val(formatTime(max));
}

function formatTime(minutes) {
    var hours = Math.floor(minutes / 60);
    var mins = minutes % 60;
    return (
        hours.toString().padStart(2, '0') +
        ':' +
        mins.toString().padStart(2, '0')
    );
}
